import { useCallback } from "react";
import type { UseQueryResult } from "@tanstack/react-query";
import { ResourceEnum } from "src/constants/constants.ts";
import { FormAction } from "src/components/Form/Form.types.ts";
import type { CreateFormData } from "src/admin/forms/accounting-posting/types.ts";
import { useSnackbar } from "src/App/App.hooks.ts";
import type { TFunction } from "i18next";
import { AccountingPostingMarketplaceError } from "src/components/Form/components/AccountingPostingMarketplaceError/AccountingPostingMarketplaceError.tsx";

export const useProcessQueryResultOnRefresh = ({
  t,
  resource,
  action,
}: {
  t: TFunction;
  resource: string;
  action: FormAction;
}) => {
  const snackbar = useSnackbar();
  return useCallback(
    (queryResult: UseQueryResult) => {
      if (
        resource === ResourceEnum.AccountingPosting &&
        action === FormAction.Create
      ) {
        const data = queryResult.data as CreateFormData;

        if (data.data.is_marketplace_transaction) {
          const errors = data.data.marketplace.errors;
          if (errors.length > 0) {
            const key = "marketplace-error" + errors.join(",");

            snackbar.error({
              autoHideDuration: Infinity,

              flash: true,
              id: key,
              message: (
                <AccountingPostingMarketplaceError
                  title={t("marketplaceErrorOrders")}
                  errors={errors}
                />
              ),
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          }
        }
      }
    },
    [snackbar, t, resource, action],
  );
};
